import { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";

function Loading() {

  const [showLoading, setShowLoading] = useState(false);
  const [showErrorLoading, setShowErrorLoading] = useState(false);

  const roles = useSelector((state) => state.role);

  useEffect(() => {
    const timerLoading = setTimeout(() => {
      setShowLoading(true);
    }, 1500);

    const timerErrorLoading = setTimeout(() => {
      setShowErrorLoading(true);
    }, 60000);

    return () => {
      clearTimeout(timerLoading);
      clearTimeout(timerErrorLoading);
    }
  }, []);

  const renderLoadingData = () => {
    return roles?.authorities === null ? (
      <Fragment>
        <div
          className="rtds-loading-status"
          aria-live="polite"
          aria-busy="true"
          role="status"
        >
          <div className="rtds-loading-results rtds-grid rtds-font-bold rtds-text-center rtds-gap-8 rtds-justify-center rtds-justify-items-center rtds-py-20">
            <svg
              className="rtds-icon rtds-fill-current rtds-w-12 rtds-h-12 rtds-animate-spin"
              aria-hidden="true"
              focusable="false"
              role="img"
            >
              <use xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`} />
            </svg>

            <h2 className="rtds-heading-3">
              Caricamento in corso<span className="dots">...</span>
            </h2>
          </div>
        </div>
      </Fragment>
    ) : roles?.authorities === undefined || showErrorLoading ? (
      <Fragment>
        <div className="rtds-mx-auto " style={{ maxWidth: "360px" }}>
          <article className="rtds-text-error-dark rtds-card rtds-card--information-left-icon rtds-card--horizontal rtds-card--horizontal-left rtds-group/card">
            <div className="rtds-card__icon ">
              <svg
                className="rtds-icon rtds-text-error-dark rtds-w-12 rtds-h-12"
                aria-hidden="true"
                focusable="false"
                role="img"
              >
                <use
                  xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--exclamation-triangle`}
                />
              </svg>
            </div>

            <div className="rtds-card__content">
              <div className="rtds-card__heading">
                <h3 className="rtds-card__title">Errore caricamento</h3>
              </div>

              <div className="rtds-card__description ">
                <p className="rtds-body-lg">
                  Si consiglia di ricaricare la pagina o di provare ad accedere
                  più tardi.
                </p>
              </div>
            </div>
          </article>
        </div>
      </Fragment>
    ) : (
      <></>
    );
  }

  return (
    <div className='rtds-container rtds-my-12' hidden={!showLoading}>
      
       
          { renderLoadingData() }
        
      
    </div>
  );
};

export default Loading;
